import { SidebarItemsType } from "@/types/sidebar";

import {
  BookOpen,
  Briefcase,
  Calendar,
  CheckSquare,
  CreditCard,
  Grid,
  Heart,
  Layout,
  List,
  Map,
  ShoppingCart,
  Package,
  PieChart,
  Sliders,
  Users,
} from "lucide-react";

const pagesSection = [
  {
    href: "/dashboard",
    icon: Layout,
    title: "Dashboard",
  },
  {
    href: "/users",
    icon: Layout,
    title: "Users",
    children: [
      {
        href: "/users/authentications",
        title: "Authentications",
      },
      {
        href: "/users/all",
        title: "All Users",
      },
    ],
  },
] as SidebarItemsType[];

const docsSection = [
  {
    href: "/documentation/welcome",
    icon: BookOpen,
    title: "Documentation",
  },
  {
    href: "/changelog",
    icon: List,
    title: "Changelog",
    badge: "v5.0.0",
  },
] as SidebarItemsType[];

const navItems = [
  {
    pages: pagesSection
  },
];

export default navItems;
